//@ts-check
import React from 'react';
import Formatter from '../../../formatter';
/**@type {import('../types').DataType<import('./types').StageBasicDataModel>} */

var JOURNEY_STAGE_DATA_TYPE = {
  data: {
    url: '/backend/journeys/{journeyId}/stages/basic',
    dataKey: 'journeyStages',
    idKeyProp: 'Id',
    onBeforeRequest: function onBeforeRequest(props, request) {
      if (props && props.dataProps) {
        return {
          url: request.url.replace('{journeyId}', props.dataProps.journeyId)
        };
      }
    }
  },
  placeholders: {
    label: function label(data) {
      return data.Name;
    },
    type: 'stage'
  },
  columns: [{
    id: 'Name',
    formatter: function formatter(_ref) {
      var data = _ref.data;
      return React.createElement(Formatter.Text, {
        value: data.Name
      });
    }
  }, {
    formatter: function formatter(_ref2) {
      var data = _ref2.data;
      return React.createElement(Formatter.Text, {
        value: data.Description
      });
    }
  }],
  thumbnail: {
    icon: function icon() {
      return 'stage';
    },
    text: function text(data) {
      return data.Name;
    }
  }
};
export default JOURNEY_STAGE_DATA_TYPE;